module.exports = __webpack_public_path__ + "assets/img/17_946_big.cb0555b7.jpg";